<template>
  <Nav></Nav>
  <main class="project">
    <back-button></back-button>
    <ProjectEditor :edit="true" :orgSlug="orgSlug" :prjSlug="prjSlug"></ProjectEditor>
    <h2>テンプレートPDF</h2>
    <Table :data="data" :headers="headers" :linkCols="linkCols" :newUri="newUri" :newCaption="newCaption"></Table>
  </main>
  <Dialog ref="error" class="dialog">
    <h4 class="title">Error</h4>
    <div class="message">
      <p class="text">{{ error.message }}</p>
    </div>
    <div class="action">
      <button class="btn btn-light" @click="errorClose">Close</button>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Dialog from '@/components/Dialog.vue';
import Nav from '@/components/Nav.vue';
import ProjectEditor from '@/components/ProjectEditor.vue';
import Table from '@/components/Table.vue';
import { Template } from '@/lib/template';

export default defineComponent({
  name: 'Project',
  components: {
    BackButton,
    Dialog,
    Nav,
    ProjectEditor,
    Table,
  },
  data() {
    return {
      prjSlug: this.$route.params.prj_slug as string,
      orgSlug: this.$route.params.org_slug as string,
      data: [] as string[][],
      linkCols: [] as string[][],
      headers: [] as string[],
      newUri: '',
      newCaption: '新しいテンプレートPDF',
      error: {
        message: '',
      },
    };
  },
  async mounted() {
    this.newUri = `/organizations/${this.orgSlug}/projects/${this.prjSlug}/template/new`;
    try {
      const tmpl = new Template(this.orgSlug, this.prjSlug);
      const data = await tmpl.all();
      if (data) {
        for (const row of data) {
          this.data.push([row.name]);
          this.linkCols.push([`./${this.prjSlug}/template/${row.slug}`]);
        }
        this.headers.push('Template');
      }
    } catch (e) {
      if (e instanceof Error) {
        this.error.message = e.message;
        (this.$refs.error as InstanceType<typeof Dialog>)?.open();
      }
      console.warn(e);
    }
  },
  methods: {
    errorClose() {
      (this.$refs.error as InstanceType<typeof Dialog>)?.close();
      this.$router.go(0);
    },
  },
});
</script>

<style lang="scss" scoped>
</style>
